<div class="formgrid grid">
  <ng-container *ngFor="let item of formItems; trackBy: identify">
    <div ngClass="{{ item.className }} mb-4" *ngIf="!item?.hidden">
      <ng-container [ngSwitch]="item.controlType">
        <app-text-field
          *ngSwitchCase="'textbox'"
          [item]="item"
          [form]="form"
        ></app-text-field>
        <app-dropdown *ngSwitchCase="'dropdown'" [item]="item" [form]="form">
        </app-dropdown>
        <app-textarea
          *ngSwitchCase="'textarea'"
          [item]="item"
          [form]="form"
        ></app-textarea>
        <app-inputnumber
          *ngSwitchCase="'inputNumber'"
          [item]="item"
          [form]="form"
        ></app-inputnumber>
        <app-datepicker
          *ngSwitchCase="'calendar'"
          [item]="item"
          [form]="form"
        ></app-datepicker>
        <app-multiselect
          *ngSwitchCase="'multiselect'"
          [item]="item"
          [form]="form"
        >
        </app-multiselect>
        <app-radio-button *ngSwitchCase="'radio'" [item]="item" [form]="form">
        </app-radio-button>
        <app-checkbox *ngSwitchCase="'checkbox'" [item]="item" [form]="form">
        </app-checkbox>
        <app-buttonset *ngSwitchCase="'buttonset'" [item]="item" [form]="form">
        </app-buttonset>
        <app-input-mask *ngSwitchCase="'inputmask'" [item]="item" [form]="form">
        </app-input-mask>
      </ng-container>
    </div>
  </ng-container>
</div>
